/**
 * 
 * 
 * Left.js
 * 
 * 
 */

import React, { Component } from 'react'
import { Container } from 'react-bootstrap';
 
 export default class Left extends Component {

    static displayName = Left.name;

     render() {


         return (

            <Container style={{ backgroundColor: '', paddingTop: '60px' }}>
                 
            <span style={{ paddingLeft: '10px', paddingTop: '0px', fontSize: '45px' }}>
                The Problem
            </span>

            <p style={{ padding: '20px', paddingTop: '20px', fontSize: '20px', fontWeight: 'lighter', textAlign: 'left' }}>
              It is expensive and time consuming for African businesses/entrepreneurs to build a mobile app and start an online business. In Ethiopia, it's even more challenging because there are no reliable methods of digital payment. Meaning there are no credit cards, international banks or online payment providers in the country.
            </p>

         </Container>


         );


     }


 }
 

 

